export default __webpack_public_path__ + "static/media/game-bg.8f5deb8c.png";